import { MIX_PANEL } from '../../const';

import Skills from './icons/Skills';
import SmartSkills from './icons/SmartSkills';
import Faq from './icons/Faq';
import Search from './icons/Search';
import SmallTalk from './icons/SmallTalk';
import BusinessManager from './icons/BusinessManager';
import Settings from './icons/Settings';
import AgentEscalation from './icons/AgentEscalation';
import WebGuide from './icons/WebGuide';
import AIRecommendationsIcon from 'relements/build/esm/ui/icons/AIRecommendationsIcon';

const Options = [
  {
    icon: Skills,
    text: 'Skills',
    type: 'option',
    actionType: 'openSkills',
    identifier: '/stories/',
    path: (data) =>
      `/v2/bots/${data.domainId}/stories/${data.storyId}/substories`,
    mixPanelEvent: (tracker, payload) => {
      tracker.track({
        event: MIX_PANEL.SIDEBAR.SKILL_ICON_CLICKED,
        payload: { ...payload },
      });
    },
  },
  {
    icon: AIRecommendationsIcon,
    text: 'AI Agents',
    type: 'option',
    actionType: 'url',
    identifier: '/ai-agents',
    path: (data) => `/ai-agents-project/${data.domainId}`,
    mixPanelEvent: (tracker, payload) => {
      tracker.track({
        event: MIX_PANEL.SIDEBAR.AI_AGENTS_ICON_CLICKED,
        payload: { ...payload },
      });
    },
  },
  {
    icon: WebGuide,
    text: 'AI Site Sync',
    type: 'option',
    actionType: 'url',
    identifier: '/webguide',
    path: (data) => `/webguide/${data.domainId}/${data.businessId}`,
    mixPanelEvent: (tracker, payload) => {
      tracker.track({
        event: MIX_PANEL.SIDEBAR.WG_ICON_CLICKED,
        payload: { ...payload },
      });
    },
  },
  {
    icon: Faq,
    text: 'FAQs',
    type: 'option',
    actionType: 'url',
    identifier: '/general-nodes',
    path: (data) => `/bot/${data.domainId}/general-nodes`,
    mixPanelEvent: (tracker, payload) => {
      tracker.track({
        event: MIX_PANEL.SIDEBAR.FAQ_ICON_CLICKED,
        payload: { ...payload },
      });
    },
  },
  {
    icon: SmallTalk,
    text: 'Small Talks',
    type: 'option',
    actionType: 'url',
    identifier: '/smalltalk',
    path: (data) => `/v2/bots/${data.domainId}/smalltalk`,
    mixPanelEvent: (tracker, payload) => {
      tracker.track({
        event: MIX_PANEL.SIDEBAR.SMALL_TALK_ICON_CLICKED,
        payload: { ...payload },
      });
    },
  },
  {
    type: 'divider',
  },
  {
    icon: Search,
    text: 'Search',
    type: 'option',
    actionType: 'showSearch',
    visible: true,
    mixPanelEvent: (tracker, payload) => {
      tracker.track({
        event: MIX_PANEL.SIDEBAR.SEARCH_ICON_CLICKED,
        payload: { ...payload },
      });
    },
  },
  {
    type: 'divider',
  },
  {
    icon: BusinessManager,
    text: 'Business Manager',
    type: 'option',
    actionType: 'url',
    identifier: '/business-manager/',
    path: (data) => `/business-manager/${data.businessId}`,
    mixPanelEvent: (tracker, payload) => {
      tracker.track({
        event: MIX_PANEL.SIDEBAR.BM_ICON_CLICKED,
        payload: { ...payload },
      });
    },
  },
  {
    icon: AgentEscalation,
    text: 'Agent Escalation',
    type: 'option',
    actionType: 'url',
    identifier: '/agent-escalation',
    path: ({ domainId, clientId, businessId }) =>
      `/v2/bots/${domainId}/agent-escalation/${clientId}/${businessId}`,
    mixPanelEvent: (tracker, payload) => {
      tracker.track({
        event: MIX_PANEL.SIDEBAR.AE_ICON_CLICKED,
        payload: { ...payload },
      });
    },
  },

  {
    icon: Settings,
    text: 'Bot Settings',
    type: 'option',
    actionType: 'openSetting',
    mixPanelEvent: (tracker, payload) => {
      tracker.track({
        event: MIX_PANEL.SIDEBAR.EDIT_BOT_ICON_CLICKED,
        payload: { ...payload },
      });
    },
  },
  {
    icon: SmartSkills,
    text: 'Smart Skill Settings',
    type: 'option',
    actionType: 'openSmartSkillSettings',
    mixPanelEvent: (tracker, payload) => {
      tracker.track({
        event: MIX_PANEL.SIDEBAR.SMART_SKILL_ICON_CLICKED,
        payload: { ...payload },
      });
    },
  },
];

export default Options;
